import React from 'react';
import { FlaskConical } from 'lucide-react';
export function PLPTrustBanner() {
  return <div className="flex items-center gap-3 px-5 py-3.5 rounded-xl border border-border bg-card" data-id="element-549">
      <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-550">
        <FlaskConical className="h-4 w-4 text-primary" strokeWidth={1.75} data-id="element-551" />
      </div>
      <p className="text-[13px] text-foreground leading-snug" data-id="element-552">
        <span className="font-medium" data-id="element-553">
          Every peptide on this page is HPLC verified
        </span>{' '}
        <span className="text-muted-foreground" data-id="element-554">
          at <span className="font-mono text-foreground" data-id="element-555">≥99%</span> purity by
          an independent UK lab.
        </span>
      </p>
    </div>;
}